<table mat-table matSort class="w-full" [dataSource]="dataSource">
  <ng-container matColumnDef="createdAt">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>Created</th>
    <td *matCellDef="let data" mat-cell>
      {{ data.createdAt | moment | amDateFormat: dateFormat }}
    </td>
  </ng-container>

  <ng-container matColumnDef="prescriber">
    <th *matHeaderCellDef mat-header-cell>Prescribed By</th>
    <td *matCellDef="let data" mat-cell>{{ data.prescribedBy }}</td>
  </ng-container>

  <ng-container matColumnDef="items">
    <th *matHeaderCellDef mat-header-cell>Items</th>
    <td *matCellDef="let data" mat-cell>
      @for (item of data.items; track item.medicationName) {
        <div>{{ item.medicationName }}</div>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>Status</th>
    <td *matCellDef="let data" mat-cell>
      <pr-status-label
        class="w-20 align-middle"
        [dense]="true"
        [label]="data.status"
        [color]="data.status | map: statusColor"
      />
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th *matHeaderCellDef mat-header-cell></th>
    <td *matCellDef="let data" mat-cell>
      @if (data.prescriptionProvider === principleProvider) {
        <a href="javascript:void(0);" (click)="prescriptionSelected.emit(data)">
          {{ actionLabel() }}
        </a>
      } @else {
        <a target="_blank" [href]="data.href">
          <div class="flex items-center gap-2">
            <span>View Prescription</span>
            <mat-icon>open_in_new</mat-icon>
          </div>
        </a>
      }
    </td>
  </ng-container>

  <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
  <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
</table>
